import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TelemetryHUDState {
  /** Whether the HUD overlay is visible */
  isVisible: boolean;
  /** Overlay opacity (0-1) */
  opacity: number;
  /** Whether to show skeleton connections */
  showSkeleton: boolean;
  /** Whether to show hand landmarks */
  showHands: boolean;
  /** Whether to show pose landmarks */
  showPose: boolean;
  
  // Actions
  setVisible: (visible: boolean) => void;
  toggleVisible: () => void;
  setOpacity: (opacity: number) => void;
  setShowSkeleton: (show: boolean) => void;
  setShowHands: (show: boolean) => void;
  setShowPose: (show: boolean) => void;
  reset: () => void;
}

const initialState = {
  isVisible: false,
  opacity: 0.8,
  showSkeleton: true,
  showHands: true,
  showPose: true,
};

export const useTelemetryHUD = create<TelemetryHUDState>()(
  persist(
    (set, get) => ({
      ...initialState,
      
      setVisible: (visible: boolean) => {
        set({ isVisible: visible });
      },
      
      toggleVisible: () => {
        set((state) => ({ isVisible: !state.isVisible }));
      },
      
      setOpacity: (opacity: number) => {
        const clampedOpacity = Math.max(0, Math.min(1, opacity));
        set({ opacity: clampedOpacity });
      },
      
      setShowSkeleton: (show: boolean) => {
        set({ showSkeleton: show });
      },
      
      setShowHands: (show: boolean) => {
        set({ showHands: show });
      },
      
      setShowPose: (show: boolean) => {
        set({ showPose: show });
      },
      
      reset: () => {
        set(initialState);
      },
    }),
    {
      name: 'telemetry-hud-settings',
      version: 1,
    }
  )
);

export default useTelemetryHUD;
